import React, {useEffect,useState} from "react";
import { PropTypes } from 'prop-types';
import { Row, Col } from "antd";
import _ from 'lodash';
import {
  PillButtonAdd,
  RowWrapper,
  PillButtonAddressWrap,
  LabelWrapper,
  EmailWrapper,
  EmailTitleWrapper,
  CheckWrap,
  FlexWrap,
  AddressWrap,
  CheckboxEmail
} from "../styles";
import {
  InputWrapper,
  TitleWrapper,
  InputWrapperDrop,
  SelectOptionMainWrapper,
  TitleMarginTop,
  SelectdropwownStyles,
  FormItemWrapper
} from "../styles";
import {
  TitleWrapperPrimary,
  Underlinelink,
  RadioWrapper,
  PrimaryElement
} from "../styles";

import InputComponent from "./InputComponent";
import SelectComponent from "./SelectComponent";
import Zipcode from "../../../../../CommonComponents/Zipcode/Zipcode";
import { CapsuleButton } from "../../../../../CommonComponents/Commons/commonComponents";
import { RadioButton } from "../../../../../CommonComponents/commonStyles";

export default function AddressForm(props) {
  return (
    <RowWrapper>
    <EmailWrapper>
      <FlexWrap>
        <AddressWrap>
          <EmailTitleWrapper>
            <LabelWrapper>Address</LabelWrapper>
          </EmailTitleWrapper>
        </AddressWrap>
        {props.state.advisorType !== "Primary" &&
          <CheckboxEmail checked={props.state.addressChecked} data-test="checkbox-primary-advisor" onChange={e => props.sameAddr(e)} id={"chkEmail"+props.id}>
            <CheckWrap>Use same address as primary advisor</CheckWrap>
          </CheckboxEmail>
        }
      </FlexWrap>
    </EmailWrapper>
    <RowWrapper>
      {props.state.advisorType === "Primary" ? (
        <>
          {props.state.primaryAdvisor.addresses
            && props.state.primaryAdvisor.addresses.map(
                (data, index) => {
                  return (
                    <div key={index + 1}>
                      <Row gutter={24}>
                        <Col lg={{ span: 8 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>Address Type</TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapperDrop >
                              <SelectOptionMainWrapper>
                                <SelectdropwownStyles>
                                  <div
                                    id={"AddressTypePriItem" + index}
                                    style={{ position: "relative" }}
                                    className="npa-account"
                                  >
                                    <SelectComponent
                                      title="Address Type"
                                      id={
                                        props.state.advisorType +
                                        "AddressType" +
                                        index
                                      }
                                      data-test="address-type"
                                      onBlur={event => {
                                        props.handleDropDownBlur(
                                          event,
                                          "addressType",
                                          index
                                        );
                                      }}
                                      onSelect={e =>
                                        props.handleDropDownChange(
                                          index,
                                          "addresses",
                                          "addressType",
                                          e
                                        )
                                      }
                                      value={
                                        data.addresstype != ""
                                          ? data.addresstype : undefined
                                      }
                                      dropdown = {props.handleAddressTypeDropdown(props.state.addressDropDown,props.state.primaryAdvisor.addresses,index) }
                                      placeholder="- Select -"
                                    />
                                    {props.state.primaryErrors
                                      .addressType && (
                                      <div>
                                        {
                                          props.state.primaryErrors
                                            .addressType[index]
                                        }
                                      </div>
                                    )}
                                  </div>
                                </SelectdropwownStyles>
                              </SelectOptionMainWrapper>
                            </InputWrapperDrop>
                          </FormItemWrapper>
                        </Col>
                        {props.state.primaryAdvisor.addresses.length >
                          1 && (
                          <Col lg={{ span: 8 }} md={{ span: 10 }}>
                            <TitleWrapperPrimary>
                              <RadioWrapper>
                                <RadioButton
                                  onChange={e =>
                                    props.handleRadioChange(
                                      index,
                                      "address",
                                      e
                                    )
                                  }
                                  data-test="primary-address"
                                  checked={data.primary}
                                  id={props.id && ("rdAddress"+index+props.id)}
                                >
                                  <PrimaryElement>
                                    Primary Address
                                  </PrimaryElement>
                                </RadioButton>
                              </RadioWrapper>
                              {!data.primary && (
                                <Underlinelink
                                  onClick={e =>
                                    props.handleRemove(
                                      index,
                                      "address",
                                      [
                                        "addressType",
                                        "line1",
                                        "city",
                                        "state",
                                        "zipcode",
                                        "country"
                                      ],
                                      e
                                    )
                                  }

                                id={props.id && ("anrRemoveAddress"+index+props.id)}
                                
                                >
                                  Remove
                                </Underlinelink>
                              )}
                            </TitleWrapperPrimary>
                          </Col>
                        )}
                      </Row>

                      <Row gutter={16}>
                        <Col lg={{ span: 16 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>Address Line 1</TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapper>
                              <InputComponent
                                ariaLabel="address-line1"
                                title="Address Line 1"
                                id={"AddressLine1" + index}
                                name="line1"
                                maxLength="50"
                                data-test = "address-line-1"
                                onBlur={event => {
                                  props.handleInputBlur(
                                    event,
                                    "line1",
                                    index
                                  );
                                }}
                                onChange={e =>
                                  props.handleArrayChange(
                                    index,
                                    "addresses",
                                    e
                                  )
                                }
                                placeholder="Enter address line 1"
                                value={
                                  data.line1 !== "" && data.line1
                                }
                              />
                              {props.state.primaryErrors.line1 && (
                                <div>
                                  {
                                    props.state.primaryErrors.line1[
                                      index
                                    ]
                                  }
                                </div>
                              )}
                            </InputWrapper>
                          </FormItemWrapper>
                        </Col>
                      </Row>

                      <Row gutter={16}>
                        <Col lg={{ span: 16 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>
                                  Address Line 2 (optional)
                                </TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapper>
                              <InputComponent
                                ariaLabel="address-line2"
                                title="Address Line 2"
                                id={"AddressLine2" + index}
                                name="line2"
                                data-test = "address-line-2"
                                onChange={e =>
                                  props.handleArrayChange(
                                    index,
                                    "addresses",
                                    e
                                  )
                                }
                                maxLength="50"
                                placeholder="Enter address line 2"
                                value={
                                  data.line2 != "" && data.line2 
                                }
                              />
                            </InputWrapper>
                          </FormItemWrapper>
                        </Col>
                      </Row>

                      <Row gutter={16}>
                        <Col lg={{ span: 16 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>
                                  Address Line 3 (optional)
                                </TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapper>
                              <InputComponent
                                ariaLabel="address-line3"
                                title="Enter address line 3"
                                id={"AddressLine3" + index}
                                maxLength="50"
                                name="line3"
                                data-test = "address-line-3"
                                onChange={e =>
                                  props.handleArrayChange(
                                    index,
                                    "addresses",
                                    e
                                  )
                                }
                                placeholder="Enter address line 3"
                                value={
                                  data.line3 !== "" && data.line3 
                                }
                              />
                            </InputWrapper>
                          </FormItemWrapper>
                        </Col>
                      </Row>
                      <Row gutter={24}>
                        {/* country */}
                        <Col lg={{ span: 9 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>Country</TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapperDrop>
                              <SelectOptionMainWrapper>
                                <SelectdropwownStyles>
                                  <SelectComponent
                                    id={
                                      props.state.advisorTypes +
                                      "Country" +
                                      index
                                    }
                                    title="Country"
                                    data-test = "country-dropdown"
                                    onSelect={e =>{
                                      props.dropDownHandleChange(
                                        index,
                                        "country",
                                        e
                                      )
                                    }

                                    }
                                    name="country"
                                    onBlur={event => {
                                      props.handleDropDownBlur(
                                        event,
                                        "country",
                                        index
                                      );
                                    }}
                                    placeholder="- Select -"
                                    value={
																			data.country !== '' ? 
                                      props.filterDropDownData(data.country,props.state.countryDropDown,'country') : ''
                                    }
                                    dropdown={props.state.countryDropDown}
                                    disabled={props.zipCodeData[`PrimaryZipcode${index + 1}`] && props.zipCodeData[`PrimaryZipcode${index + 1}`].loading}
                                  />
                                  {props.state.primaryErrors
                                    .country && (
                                    <div>
                                      {
                                        props.state.primaryErrors
                                          .country[index]
                                      }
                                    </div>
                                  )}
                                </SelectdropwownStyles>
                              </SelectOptionMainWrapper>
                            </InputWrapperDrop>
                          </FormItemWrapper>
                        </Col>

                        {/* zip */}
                        <Col lg={{ span: 9 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>Zip Code</TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapper>
                            <Zipcode
                              ariaLabel="zipcode"
                              id={"primaryZipCode" + index}
                              isUS={data.country === '0'}
                              name='zipcode'
                              id={props.id && ("txtZipCode"+index+props.id)}
                              placeholder='Enter Zipcode'
                              title={`PrimaryZipcode${index + 1}`}
                              maxLength={data.country == '0' && '20'}
                              data-test="zip-code"
                              onBlur={event => {
                                props.handleInputBlur(event, 'zipcode', index);
                              }}
                              onChange={e => props.handleArrayChange(index, 'addresses', e)}
                              value={data.zipcode !== '' ? data.zipcode : ''}
                              />
                                {props.state.primaryErrors.zipcode && (
                                <div>
                                  {
                                    props.state.primaryErrors.zipcode[
                                      index
                                    ]
                                  }
                                </div>
                              )}
                            </InputWrapper>
                          </FormItemWrapper>
                        </Col>

                        {/* city */}
                        <Col lg={{ span: 9 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>City</TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapper>
                              <InputComponent
                                ariaLabel="city"
                                title="City"
                                id={"City" + index}
                                name="city"
                                maxLength={100}
                                data-test="city-field"
                                onBlur={event => {
                                  props.handleInputBlur(
                                    event,
                                    "city",
                                    index
                                  );
                                }}
                                onChange={e => {
                                  props.handleArrayChange(
                                    index,
                                    "addresses",
                                    e
                                  )
                                }
                                }
                                placeholder="Enter city"
                                value={
																	data.city !== '' ? data.city : ''
                                }
                                disabled={props.zipCodeData[`PrimaryZipcode${index + 1}`] && props.zipCodeData[`PrimaryZipcode${index + 1}`].loading}
                              />
                              {props.state.primaryErrors.city && (
                                <div>
                                  {
                                    props.state.primaryErrors.city[
                                      index
                                    ]
                                  }
                                </div>
                              )}
                            </InputWrapper>
                          </FormItemWrapper>
                        </Col>

                        {/* state */}
                        <Col lg={{ span: 9 }} md={{ span: 10 }}>
                          {data.country == "0" ? (
                            <FormItemWrapper
                              colon={false}
                              label={
                                <TitleMarginTop>
                                  <TitleWrapper>State</TitleWrapper>
                                </TitleMarginTop>
                              }
                            >
                              <InputWrapperDrop>
                                <SelectOptionMainWrapper>
                                  <SelectdropwownStyles>
                                    <SelectComponent
                                      title="State"
                                      id={
                                        props.state.advisorType +
                                        "state" +
                                        index
                                      }
                                      data-test="state-field"
                                      onBlur={event => {
                                        props.handleDropDownBlur(event, "state", index);
                                      }}
                                      onSelect={e => {
                                        props.dropDownHandleChange(
                                          index,
                                          "state",
                                          e
                                        )
                                      }
                                      }
                                      name="state"
                                      placeholder="Enter state"
                                      value={
                                        data.state !== '' ? 
                                        props.filterDropDownData(
                                          data.state,
                                          props.state.statesDropDown
                                        ) : ''
                                      }
                                      dropdown = {props.state.statesDropDown}
                                      disabled={props.zipCodeData[`PrimaryZipcode${index + 1}`] && props.zipCodeData[`PrimaryZipcode${index + 1}`].loading}
                                    />
                                    {props.state.primaryErrors.state && (
                                      <div>
                                        {
                                          props.state.primaryErrors.state[
                                            index
                                          ]
                                        }
                                      </div>
                                    )}
                                  </SelectdropwownStyles>
                                </SelectOptionMainWrapper>
                              </InputWrapperDrop>
                            </FormItemWrapper>
                          ) : (
                            <FormItemWrapper
                              colon={false}
                              label={
                                <TitleMarginTop>
                                  <TitleWrapper>State</TitleWrapper>
                                </TitleMarginTop>
                              }
                            >
                              <InputWrapper>
                                <InputComponent
                                  ariaLabel="state"
                                  title="State"
                                  id={"state" + index}
                                  name="state"
                                  maxLength={100}
                                  data-test="state-field-2"
                                  onBlur={event => {
                                    props.handleInputBlur(
                                      event,
                                      "state",
                                      index
                                    );
                                  }}
                                  onChange={e =>
                                    props.handleArrayChange(
                                      index,
                                      "addresses",
                                      e
                                    )
                                  }
                                  value={
                                   data.state 
                                  }
                                  placeholder="Enter state"
                                />
                                {props.state.primaryErrors.state && (
                                  <div>
                                    {
                                      props.state.primaryErrors.state[
                                        index
                                      ]
                                    }
                                  </div>
                                )}
                              </InputWrapper>
                            </FormItemWrapper>
                          )}
                        </Col>
                      </Row>
                    </div>
                  );
                }
              )
            }
          {props.state.primaryAdvisor.addresses &&
          props.state.primaryAdvisor.addresses.length < 4 ? (
            <PillButtonAddressWrap>
              <CapsuleButton
                iconType = "add"
                text = "Add Address"
                data-test="add-address"
                id={props.id && ("btnAddress"+props.id)}
                onClick={e => props.handleAddNewField("address", e)}
              />
            </PillButtonAddressWrap>
          ) : (
            <PillButtonAddressWrap>
              <CapsuleButton
                iconType = "add"
                disabled = {true}
                text = "Add Address"
              />
            </PillButtonAddressWrap>
          )}
        </>
      ) : (
        <>
          {props.state.secondaryAdvisor.addresses
            && props.state.secondaryAdvisor.addresses.map(
                (data, index) => {
                  return (
                    <div key={index + 1}>
                      <Row gutter={24}>
                        <Col lg={{ span: 8 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>Address Type</TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapperDrop>
                              <SelectOptionMainWrapper>
                                <SelectdropwownStyles>
                                  <div
                                    id={"AddressPriItem" + index}
                                    style={{ position: "relative" }}
                                  
                                  >
                                    <SelectComponent
                                      title="Address Type"
                                      data-test="address-type"
                                      id={
                                        props.state.advisorType +
                                        "AddressType" +
                                        index
                                      }
                                      onBlur={event => {
                                        props.handleDropDownBlur(
                                          event,
                                          "addressType",
                                          index
                                        );
                                      }}
                                      onSelect={e =>
                                        props.handleDropDownChange(
                                          index,
                                          "addresses",
                                          "addressType",
                                          e
                                        )
                                      }
                                      value={
                                        data.addresstype != "- Select -"
                                          ? data.addresstype : undefined
                                      }
                                      placeholder="- Select -"
                                      dropdown = 
                                      {props.handleAddressTypeDropdown(props.state.addressDropDown,props.state.secondaryAdvisor.addresses,index) }
                                    />
                                    {props.state.secondaryErrors
                                      .addressType && (
                                      <div>
                                        {
                                          props.state.secondaryErrors
                                            .addressType[index]
                                        }
                                      </div>
                                    )}
                                  </div>
                                </SelectdropwownStyles>
                              </SelectOptionMainWrapper>
                            </InputWrapperDrop>
                          </FormItemWrapper>
                        </Col>
                        {props.state.secondaryAdvisor.addresses
                          .length > 1 && (
                          <Col lg={{ span: 8 }} md={{ span: 10 }}>
                            <TitleWrapperPrimary>
                              <RadioWrapper>
                                <RadioButton
                                  onChange={e =>
                                    props.handleRadioChange(
                                      index,
                                      "address",
                                      e
                                    )
                                  }
                                  checked={data.primary}
                                  id={props.id && ("rdPAddress"+index+ props.id)}
                                >
                                  <PrimaryElement>
                                    Primary Address
                                  </PrimaryElement>
                                </RadioButton>
                              </RadioWrapper>
                              {!data.primary && (
                                <Underlinelink
                                  onClick={e =>
                                    props.handleRemove(
                                      index,
                                      "address",
                                      [
                                        "addressType",
                                        "line1",
                                        "city",
                                        "state",
                                        "zipcode",
                                        "country"
                                      ],
                                      e
                                    )
                                  }
                                  id={props.id && ("anrRemoveAddressThird"+index+props.id)}
                                >
                                  Remove
                                </Underlinelink>
                              )}
                            </TitleWrapperPrimary>
                          </Col>
                        )}
                      </Row>

                      <Row gutter={16}>
                        <Col lg={{ span: 16 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>Address Line 1</TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapper>
                              <InputComponent
                                ariaLabel="address-line1"
                                title="Address Line 1"
                                id={"AddressLine1" + index}
                                name="line1"
                                maxLength="50"
                                data-test = "address-line-1"
                                onBlur={event => {
                                  props.handleInputBlur(
                                    event,
                                    "line1",
                                    index
                                  );
                                }}
                                onChange={e =>
                                  props.handleArrayChange(
                                    index,
                                    "addresses",
                                    e
                                  )
                                }
                                placeholder="Enter address line 1"
                                value={
                                  data.line1 !== "" && data.line1
                                }
                              />
                              {props.state.secondaryErrors.line1 && (
                                <div>
                                  {
                                    props.state.secondaryErrors.line1[
                                      index
                                    ]
                                  }
                                </div>
                              )}
                            </InputWrapper>
                          </FormItemWrapper>
                        </Col>
                      </Row>

                      <Row gutter={16}>
                        <Col lg={{ span: 16 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>
                                  Address Line 2 (optional)
                                </TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapper>
                              <InputComponent
                                ariaLabel="address-line2"
                                title="Address Line 2"
                                id={"AddressLine2" + index}
                                name="line2"
                                data-test = "address-line-2"
                                onChange={e =>
                                  props.handleArrayChange(
                                    index,
                                    "addresses",
                                    e
                                  )
                                }
                                maxLength="50"
                                placeholder="Enter address line 2"
                                value={
                                  data.line2 != "" && data.line2
                                }
                              />
                            </InputWrapper>
                          </FormItemWrapper>
                        </Col>
                      </Row>

                      <Row gutter={16}>
                        <Col lg={{ span: 16 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>
                                  Address line 3 (optional)
                                </TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapper>
                              <InputComponent
                                ariaLabel="address-line3"
                                title="Enter address line 3"
                                id={"AddressLine3" + index}
                                maxLength="50"
                                data-test = "address-line-3"
                                name="line3"
                                onChange={e =>
                                  props.handleArrayChange(
                                    index,
                                    "addresses",
                                    e
                                  )
                                }
                                placeholder="Enter address line 3"
                                value={
                                  data.line3 !== "" && data.line3
                                }
                              />
                            </InputWrapper>
                          </FormItemWrapper>
                        </Col>
                      </Row>
                      <Row gutter={24}>
                        {/* country */}
                        <Col lg={{ span: 8 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>Country</TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapperDrop>
                              <SelectOptionMainWrapper>
                                <SelectdropwownStyles>
                                  <SelectComponent
                                    id={
                                      props.state.advisorTypes +
                                      "Country" +
                                      index
                                    }
                                    title="Country"
                                    data-test = "country-dropdown"
                                    onSelect={e => {
																			props.resetAllZipCode(`SecondaryZipcode${index + 1}`);
                                      props.resetZipCode(`SecondaryZipcode${index + 1}`, 'country');
                                      props.dropDownHandleChange(index, "country", e)
																		}}
                                    name="country"
                                    onBlur={event => {
                                      props.handleDropDownBlur(
                                        event,
                                        "country",
                                        index
                                      );
                                    }}
                                    placeholder="- Select -"
                                    value={
																			data.country ? 
                                      props.filterDropDownData(data.country, props.state.countryDropDown,'country'): undefined
                                    }
                                    dropdown = {props.state.countryDropDown}
                                    disabled={props.zipCodeData[`SecondaryZipcode${index + 1}`] && props.zipCodeData[`SecondaryZipcode${index + 1}`].loading}
                                  />
                                  {props.state.secondaryErrors
                                    .country && (
                                    <div>
                                      {
                                        props.state.secondaryErrors
                                          .country[index]
                                      }
                                    </div>
                                  )}
                                </SelectdropwownStyles>
                              </SelectOptionMainWrapper>
                            </InputWrapperDrop>
                          </FormItemWrapper>
                        </Col>
                        {/* zip */}
                        <Col lg={{ span: 8 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>Zip Code</TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapper>
                              <Zipcode
                                ariaLabel="zipcode"
                                id={"secondaryZipCode" + index}
                                isUS={data.country === '0'}
                                name='zipcode'
                                id={"txtInput"+index+props.id}
                                placeholder='Enter Zipcode'
                                data-test="zip-code"
                                title={`SecondaryZipcode${index + 1}`}
                                maxLength={data.country == '0' && '20'}
                                onBlur={event => {
                                  props.handleInputBlur(event, 'zipcode', index);
                                }}
                                onChange={e => props.handleArrayChange(index, 'addresses', e)}
                                value={data.zipcode !== '' ? data.zipcode : ''}
                                />
                                  {props.state.secondaryErrors.zipcode && (
                                  <div>
                                    {
                                      props.state.secondaryErrors.zipcode[
                                        index
                                      ]
                                    }
                                  </div>
                                )}
                            </InputWrapper>
                          </FormItemWrapper>
                        </Col>
                      </Row>
                      <Row gutter={24}>
                        <Col lg={{ span: 8 }} md={{ span: 10 }}>
                          <FormItemWrapper
                            colon={false}
                            label={
                              <TitleMarginTop>
                                <TitleWrapper>City</TitleWrapper>
                              </TitleMarginTop>
                            }
                          >
                            <InputWrapper>
                              <InputComponent
                                ariaLabel="city"
                                title="City"
                                id={"City" + index}
                                name="city"
                                data-test="city-field"
																maxLength={100}
																onBlur={event => {
                                  props.handleInputBlur( event, "city", index);
                                }}
																onChange={e => {
                                  props.handleArrayChange(index, "addresses", e)
                                }}
                                placeholder="Enter city"
                                value={                                
																	 data.city !== '' ? data.city : ''
																}
																disabled={props.zipCodeData[`SecondaryZipcode${index + 1}`] && props.zipCodeData[`SecondaryZipcode${index + 1}`].loading}
                              />
                              {props.state.secondaryErrors.city && (
                                <div>
                                  {
                                    props.state.secondaryErrors.city[
                                      index
                                    ]
                                  }
                                </div>
                              )}
                            </InputWrapper>
                          </FormItemWrapper>
                        </Col>
                        <Col lg={{ span: 8 }} md={{ span: 10 }}>
                          {data.country == "0" ? (
                            <FormItemWrapper
                              colon={false}
                              label={
                                <TitleMarginTop>
                                  <TitleWrapper>State</TitleWrapper>
                                </TitleMarginTop>
                              }
                            >
                              <InputWrapperDrop>
                                <SelectOptionMainWrapper>
                                  <SelectdropwownStyles>
                                    <SelectComponent                                      
                                      title="State"
                                      id={
                                        props.state.advisorType +
                                        "state" +
                                        index
                                      }
                                      onBlur={event => {
                                        props.handleDropDownBlur(
                                          event,
                                          "state",
                                          index
                                        );
                                      }}
																			onSelect={e => {
                                        props.dropDownHandleChange(index, "state", e)
																			}}
                                      name="state"
                                      data-test="state-field"
                                      placeholder="Enter state"
                                      value={
																				data.state !== "" ? 
                                        props.filterDropDownData(data.state, props.state.statesDropDown,'state') : undefined
                                      }
																			dropdown = {props.state.statesDropDown}
																			disabled={props.zipCodeData[`SecondaryZipcode${index + 1}`] && props.zipCodeData[`SecondaryZipcode${index + 1}`].loading}
                                    />
                                    {props.state.secondaryErrors.state && (
                                      <div>
                                        {
                                          props.state.secondaryErrors
                                            .state[index]
                                        }
                                      </div>
                                    )}
                                </SelectdropwownStyles>
                                </SelectOptionMainWrapper>
                              </InputWrapperDrop>
                            </FormItemWrapper>
                          ) : (
                            <FormItemWrapper
                              colon={false}
                              label={
                                <TitleMarginTop>
                                  <TitleWrapper>State</TitleWrapper>
                                </TitleMarginTop>
                              }
                            >
                              <InputWrapper>
                                <InputComponent
                                  ariaLabel="state"
                                  title="State"
                                  data-test="state-field-2"
                                  id={"state" + index}
                                  name="state"
                                  maxLength={100}
                                  onBlur={event => {
                                    props.handleInputBlur(
                                      event,
                                      "state",
                                      index
                                    );
                                  }}
                                  onChange={e => props.handleArrayChange(index,"addresses",e)}
                                  value={
                                    data.state !== ""
                                      && data.country == "0"
                                        ? props.filterDropDownData(data.state,props.state.statesDropDown,'state')
                                        : data.state
                                  }
                                  placeholder="Enter state"
                                />
                                {props.state.secondaryErrors.state && (
                                  <div>
                                    {
                                      props.state.secondaryErrors
                                        .state[index]
                                    }
                                  </div>
                                )}
                              </InputWrapper>
                            </FormItemWrapper>
                          )}
                        </Col>
                      </Row>
                    </div>
                  );
                }
              )
            }
          {props.state.secondaryAdvisor.addresses &&
          props.state.secondaryAdvisor.addresses.length < 4 ? (
            <PillButtonAddressWrap>
              <CapsuleButton
                iconType = "add"
                text = "Add Address"
                data-test="add-address"
                id={props.id && ("btnAddress"+props.id)}
                onClick={e => props.handleAddNewField("address", e)}
                styles="mb-25"
              />
            </PillButtonAddressWrap>
          ) : (
            <PillButtonAddressWrap>
              <CapsuleButton
                iconType = "add"
                disabled = {true}
                text = "Add Address"
              />
            </PillButtonAddressWrap>
          )}
        </>
      )}
    </RowWrapper>
  </RowWrapper>
  )
}

AddressForm.propTypes = {
  dropDownHandleChange: PropTypes.func,
  filterDropDownData: PropTypes.func,
  filterDropDownDataWithValue: PropTypes.func,
  handleAddNewField: PropTypes.func,
  handleArrayChange: PropTypes.func,
  handleDropDownBlur: PropTypes.func,
  handleDropDownChange: PropTypes.func,
  handleInputBlur: PropTypes.func,
  handleRadioChange: PropTypes.func,
  handleRemove: PropTypes.func,
  id: PropTypes.string,
  resetAllZipCode: PropTypes.func,
  resetZipCode: PropTypes.func,
  sameAddr: PropTypes.func,
  state: PropTypes.object,
  storeZipCode: PropTypes.func,
  zipCodeData: PropTypes.any,
}